import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SettingsIcon from '@mui/icons-material/Settings';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import WbIncandescentTwoToneIcon from '@mui/icons-material/WbIncandescentTwoTone';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ExtensionTwoToneIcon from '@mui/icons-material/ExtensionTwoTone';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ImageSearchTwoToneIcon from '@mui/icons-material/ImageSearchTwoTone';
import GroupIcon from '@mui/icons-material/Group';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import styles from "./sidebar.module.scss";

const drawerWidth = 240;

const navigateList = [
  {
    title: 'Leagues',
    path: 'leagues',
    icon: <ListAltIcon />
  },
  // {
  //   title: 'Upcoming matches',
  //   path: 'upcoming-matches',
  //   icon: <UpcomingIcon />
  // },
  // {
  //   title: 'Live matches',
  //   path: 'live-matches',
  //   icon: <LiveTvIcon />
  // },
  {
    title: 'Groups',
    path: 'groups',
    icon: <Diversity3Icon />
  },
  {
    title: 'Competitions',
    path: 'competitions',
    icon: <ExtensionTwoToneIcon />
  },
  {
    title: 'Live Quiz',
    path: 'live-quiz',
    icon: <WbIncandescentTwoToneIcon />
  },
  {
    title: 'Media Library',
    path: 'media-library',
    icon: <ImageSearchTwoToneIcon />
  },
  {
    title: 'Challenge settings',
    path: 'challenge-settings',
    icon: <SettingsIcon />
  },
  {
    title: 'Application settings',
    path: 'application-settings',
    icon: <DisplaySettingsIcon />
  },
  {
    title: 'Users',
    path: 'users',
    icon: <GroupIcon />
  },
  {
    title: 'Reports',
    path: 'reports',
    icon: <ReportProblemIcon color="warning" />
  }
];

export function SideBar() {
  const location = useLocation();
  
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Hajem admin panel
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' }
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {navigateList.map((item, index) => (
              <Link
                className={clsx(styles.link, location.pathname.includes(item.path) && styles.openTab)}
                to={`/${item.path}`}
                key={index.toString()}
              >
                <ListItemButton>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.title} />
                </ListItemButton>
              </Link>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </Box>
  );
}